import { ETrackStoreOrderType } from 'entities/TrackStore/TrackStore.models';

export const STORE_CARD_ORDERS_HEIGHT = 386;
export const ZOR_MAINTENANCE_TARGET_MINS = 12;
export const STORE_ORDERS_LIMIT = 10;

export const trackStoreOrderTypeOptions = [
  { value: ETrackStoreOrderType.Reg, label: 'Reg Order' },
  { value: ETrackStoreOrderType.Adv, label: 'Adv Order' },
];
